class s {
  constructor() {
  }
  validate(t) {
    switch (t = t.toUpperCase(), t.slice(0, 2)) {
      case "AD":
        return !!t.match(/^AD[0-9]{22}$/);
      case "AE":
        return !!t.match(/^AE[0-9]{21}$/);
      case "AL":
        return !!t.match(/^AL[0-9]{26}$/);
      case "AT":
        return !!t.match(/^AT[0-9]{20}$/);
      case "AZ":
        return !!t.match(/^AZ[0-9]{2}[A-Z]{4}[0-9]{20}$/);
      case "BA":
        return !!t.match(/^BA[0-9]{18}$/);
      case "BE":
        return !!t.match(/^BE[0-9]{14}$/);
      case "BG":
        return !!t.match(/^BG[0-9]{2}[A-Z]{4}[0-9]{14}$/);
      case "BH":
        return !!t.match(/^BH[0-9]{2}[A-Z]{4}[0-9]{14}$/);
      case "BR":
        return !!t.match(/^BR[0-9]{25}[A-Z][0-9]$/);
      case "CR":
        return !!t.match(/^CR[0-9]{19}$/);
      case "CH":
        return !!t.match(/^CH[0-9]{19}$/);
      case "CY":
        return !!t.match(/^CY[0-9]{26}$/);
      case "CZ":
        return !!t.match(/^CZ[0-9]{22}$/);
      case "DE":
        return !!t.match(/^DE[0-9]{20}$/);
      case "DK":
        return !!t.match(/^DK[0-9]{16}$/);
      case "DO":
        return !!t.match(/^DO[0-9]{2}[A-Z]{2}[0-9]{20}$/);
      case "EE":
        return !!t.match(/^EE[0-9]{18}$/);
      case "ES":
        return !!t.match(/^ES[0-9]{22}$/);
      case "FI":
        return !!t.match(/^FI[0-9]{16}$/);
      case "FO":
        return !!t.match(/^FO[0-9]{16}$/);
      case "FR":
        return !!t.match(/^FR[0-9]{19}[A-Z][0-9]{5}$/);
      case "GB":
        return !!t.match(/^GB[0-9]{2}[A-Z]{4}[0-9]{14}$/);
      case "GE":
        return !!t.match(/^GE[0-9]{2}[A-Z]{2}[0-9]{16}$/);
      case "GI":
        return !!t.match(/^GI[0-9]{2}[A-Z]{4}[0-9]{15}$/);
      case "GL":
        return !!t.match(/^GL[0-9]{16}$/);
      case "GR":
        return !!t.match(/^GR[0-9]{25}$/);
      case "GT":
        return !!t.match(/^GT[0-9]{2}[A-Z]{4}[0-9]{20}$/);
      case "HR":
        return !!t.match(/^HR[0-9]{19}$/);
      case "HU":
        return !!t.match(/^HU[0-9]{26}$/);
      case "IE":
        return !!t.match(/^IE[0-9]{2}[A-Z]{4}[0-9]{14}$/);
      case "IL":
        return !!t.match(/^IL[0-9]{21}$/);
      case "IS":
        return !!t.match(/^IS[0-9]{24}$/);
      case "IT":
        return !!t.match(/^IT[0-9]{2}[A-Z][0-9]{22}$/);
      case "KW":
        return !!t.match(/^KW[0-9]{2}[A-Z]{4}[0-9]{22}$/);
      case "KZ":
        return !!t.match(/^KZ[0-9]{5}[A-Z]{3}[0-9]{10}$/);
      case "LB":
        return !!t.match(/^LB[0-9]{26}$/);
      case "LI":
        return !!t.match(/^LI[0-9]{17}[A-Z]{2}$/);
      case "LT":
        return !!t.match(/^LT[0-9]{18}$/);
      case "LU":
        return !!t.match(/^LU[0-9]{18}$/);
      case "LV":
        return !!t.match(/^LV[0-9]{2}[A-Z]{4}[0-9]{13}$/);
      case "MC":
        return !!t.match(/^MC[0-9]{22}[A-Z][0-9]{2}$/);
      case "MD":
        return !!t.match(/^MD[0-9]{2}[A-Z]{2}[0-9]{18}$/);
      case "ME":
        return !!t.match(/^ME[0-9]{20}$/);
      case "MK":
        return !!t.match(/^MK[0-9]{17}$/);
      case "MR":
        return !!t.match(/^MR[0-9]{25}$/);
      case "MT":
        return !!t.match(/^MT[0-9]{2}[A-Z]{4}[0-9]{12}[A-Z]{7}[0-9]{3}[A-Z]$/);
      case "MU":
        return !!t.match(/^MU[0-9]{2}[A-Z]{4}[0-9]{19}[A-Z]{3}$/);
      case "NL":
        return !!t.match(/^NL[0-9]{2}[A-Z]{4}[0-9]{10}$/);
      case "NO":
        return !!t.match(/^NO[0-9]{13}$/);
      case "PK":
        return !!t.match(/^PK[0-9]{2}[A-Z]{4}[0-9]{16}$/);
      case "PL":
        return !!t.match(/^PL[0-9]{26}$/);
      case "PS":
        return !!t.match(/^PS[0-9]{2}[A-Z]{4}[0-9]{21}$/);
      case "PT":
        return !!t.match(/^PT[0-9]{23}$/);
      case "RO":
        return !!t.match(/^RO[0-9]{2}[A-Z]{4}[0-9]B[0-9]{14}$/);
      case "RS":
        return !!t.match(/^RS[0-9]{20}$/);
      case "SA":
        return !!t.match(/^SA[0-9]{22}$/);
      case "SE":
        return !!t.match(/^SE[0-9]{22}$/);
      case "SI":
        return !!t.match(/^SI[0-9]{17}$/);
      case "SK":
        return !!t.match(/^SK[0-9]{22}$/);
      case "SM":
        return !!t.match(/^SM[0-9]{2}[A-Z][0-9]{22}$/);
      case "TN":
        return !!t.match(/^TN[0-9]{22}$/);
      case "TR":
        return !!t.match(/^TR[0-9]{24}$/);
      case "VG":
        return !!t.match(/^VG[0-9]{2}[A-Z]{4}[0-9]{16}$/);
    }
    return !1;
  }
}
export {
  s as default
};
